import { render, staticRenderFns } from "./FcLogoutModal.vue?vue&type=template&id=8af422e8&scoped=true&"
import script from "./FcLogoutModal.vue?vue&type=script&lang=js&"
export * from "./FcLogoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af422e8",
  null
  
)

export default component.exports